<template>
    <div class="field">
        <label class="label">Price range</label>
        <div class="field has-addons">
            <p class="control">
                <input class="input" v-model="minPrice" placeholder="Min value"/>
            </p>
            <p class="control helper-to">
                <span class="button is-static">000 To:</span>
            </p>
            <p class="control">
                <input class="input" v-model="maxPrice" placeholder="Max value"/>
            </p>
            <p class="control helper-to">
                <span class="button is-static">000</span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            minPrice: {
                get: function () {
                    return this.$store.getters.getQueryPriceMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewPriceRangeMinValue', value)
                }
            },
            maxPrice: {
                get: function () {
                    return this.$store.getters.getQueryPriceMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewPriceRangeMaxValue', value)
                }
            }
        }
    }
</script>

<style scoped>
    .control {
        width: 100%;
    }
    .helper-to {
        width: 150px;
    }
</style>


<!--<script>-->
    <!--import VueSlider from 'vue-slider-component';-->

    <!--export default {-->
        <!--components: {-->
            <!--appSlider: VueSlider-->
        <!--},-->
        <!--data() {-->
            <!--return {-->
                <!--options: {-->
                    <!--min: 0,-->
                    <!--max: 300,-->
                    <!--interval: 1,-->
                    <!--tooltip: 'hover',-->
                    <!--formatter: "¥{value} thousands"-->
                <!--}-->
            <!--}-->
        <!--},-->
        <!--computed: {-->
            <!--priceValues: {-->
                <!--get: function () {-->
                    <!--return [ this.$store.getters.getQueryPriceMin, this.$store.getters.getQueryPriceMax ]-->
                <!--},-->
                <!--set: function (values) {-->
                    <!--if ( this.$store.getters.getQueryPriceMin !== values[0] ) {-->
                        <!--this.$store.dispatch('addNewPriceRangeMinValue', values[0])-->
                    <!--}-->

                    <!--if ( this.$store.getters.getQueryPriceMax !== values[1] ) {-->
                        <!--this.$store.dispatch('addNewPriceRangeMaxValue', values[1])-->
                    <!--}-->
                <!--}-->
            <!--}-->
        <!--}-->
    <!--}-->
<!--</script>-->

<!--<style scoped>-->
    <!--.control {-->
        <!--width: 90%;-->
        <!--left: 3%;-->
    <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/Auctions/Specification/PriceSlider.vue